<template>
  <div>
    <!-- KPI Cards -->
    <b-row class="match-height mb-1">
      <b-col cols="12" sm="6" xl="3">
        <b-card no-body class="card-statistics">
          <b-card-body class="statistics-body">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <span class="d-block text-muted small">Total de Receitas</span>
                <h4 class="font-weight-bolder text-success mb-0">
                  {{ formatCurrencyBrazil(totaisCards.totalReceita || 0) }}
                </h4>
                <small class="text-muted">Receitas do período</small>
              </div>
              <div class="avatar bg-light-success p-50 m-0">
                <feather-icon icon="TrendingUpIcon" size="24" class="text-success" />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" xl="3">
        <b-card no-body class="card-statistics">
          <b-card-body class="statistics-body">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <span class="d-block text-muted small">Total de Despesas</span>
                <h4 class="font-weight-bolder text-danger mb-0">
                  {{ formatCurrencyBrazil(totaisCards.totalDespesa || 0) }}
                </h4>
                <small class="text-muted">Despesas do período</small>
              </div>
              <div class="avatar bg-light-danger p-50 m-0">
                <feather-icon icon="TrendingDownIcon" size="24" class="text-danger" />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" xl="3">
        <b-card no-body class="card-statistics">
          <b-card-body class="statistics-body">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <span class="d-block text-muted small">Saldo</span>
                <h4
                  class="font-weight-bolder mb-0"
                  :class="totaisCards.saldoAtual >= 0 ? 'text-success' : 'text-danger'"
                >
                  {{ formatCurrencyBrazil(totaisCards.saldoAtual || 0) }}
                </h4>
                <small class="text-muted">Receitas - Despesas</small>
              </div>
              <div
                class="avatar p-50 m-0"
                :class="totaisCards.saldoAtual >= 0 ? 'bg-light-success' : 'bg-light-danger'"
              >
                <feather-icon
                  :icon="totaisCards.saldoAtual >= 0 ? 'DollarSignIcon' : 'AlertCircleIcon'"
                  size="24"
                  :class="totaisCards.saldoAtual >= 0 ? 'text-success' : 'text-danger'"
                />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" xl="3">
        <b-card no-body class="card-statistics">
          <b-card-body class="statistics-body">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <span class="d-block text-muted small">Total Pendente</span>
                <h4 class="font-weight-bolder text-warning mb-0">
                  {{ formatCurrencyBrazil(totaisCards.totalPendente || 0) }}
                </h4>
                <small class="text-muted">A receber / a pagar</small>
              </div>
              <div class="avatar bg-light-warning p-50 m-0">
                <feather-icon icon="ClockIcon" size="24" class="text-warning" />
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <!-- Filtros -->
        <b-card v-if="!showForm" class="mb-1">
          <b-row>
            <b-col cols="12" md="2">
              <b-form-group label="Tipo" label-for="filtro-tipo">
                <b-form-select
                  id="filtro-tipo"
                  v-model="filter.tipoTransacao"
                  :options="opcoestipoTransacao"
                  value-field="value"
                  text-field="label"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Situação" label-for="filtro-situacao">
                <b-form-select
                  id="filtro-situacao"
                  v-model="filter.situacao"
                  :options="opcoesSituacao"
                  value-field="value"
                  text-field="label"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Data Início" label-for="filtro-data-inicio">
                <b-form-input
                  id="filtro-data-inicio"
                  v-model="filter.dataInicio"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Data Fim" label-for="filtro-data-fim">
                <b-form-input
                  id="filtro-data-fim"
                  v-model="filter.dataFinal"
                  type="date"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-group label="Buscar" label-for="filtro-campo">
                <b-form-input
                  id="filtro-campo"
                  v-model="filter.campo"
                  type="text"
                  placeholder="Descrição, nome do membro..."
                  @input="handleSearch"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="1" class="d-flex align-items-center mt-50">
              <b-button variant="primary" block @click="aplicarFiltro">
                <feather-icon icon="SearchIcon" size="14" />
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <!-- Tabela -->
        <b-card v-if="!showForm" :title="tituloTabela">
          <div class="custom-search d-flex justify-content-start mb-1">
            <b-button variant="primary" @click="addNew">
              <feather-icon icon="PlusIcon" size="14" class="mr-50" />
              Incluir Lançamento
            </b-button>
          </div>

          <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="listaPagamentoRecebimentos"
            :rtl="direction"
            :is-loading.sync="isLoading"
            :pagination-options="{
              enabled: true,
              perPage: tableConfigs.size
            }"
            :total-rows="tableConfigs.totalElements"
            @on-sort-change="onSortChange"
          >
            <template slot="table-row" slot-scope="props">
              <!-- Badge Tipo -->
              <span v-if="props.column.field === 'tipoBadge'">
                <b-badge
                  :variant="getTipoBadgeVariant(props.row)"
                  pill
                >
                  {{ getTipoLabel(props.row) }}
                </b-badge>
              </span>

              <!-- Badge Situação -->
              <span v-else-if="props.column.field === 'situacao'">
                <b-badge :variant="getSituacaoBadgeVariant(props.row.situacao)" pill>
                  {{ getSituacaoLabel(props.row.situacao) }}
                </b-badge>
              </span>

              <!-- Valor formatado -->
              <span v-else-if="props.column.field === 'valor'">
                {{ formatCurrencyBrazil(props.row.valor) }}
              </span>

              <!-- Ações -->
              <span v-else-if="props.column.field === 'action'">
                <span class="d-flex align-items-center gap-50">
                  <!-- Quitar (só para ABERTO e VENCIDO) -->
                  <b-button
                    v-if="['ABERTO','VENCIDO','PAGO_A_MENOR'].includes(props.row.situacao)"
                    v-b-tooltip.hover
                    title="Quitar"
                    variant="flat-success"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="abrirModalQuitacao(props.row)"
                  >
                    <feather-icon icon="CheckCircleIcon" size="16" />
                  </b-button>

                  <!-- Editar -->
                  <b-button
                    v-b-tooltip.hover
                    title="Editar"
                    variant="flat-secondary"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="edit(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" size="16" />
                  </b-button>

                  <!-- Excluir -->
                  <b-button
                    v-b-tooltip.hover
                    title="Excluir"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="remove(props.row)"
                  >
                    <feather-icon icon="TrashIcon" size="16" />
                  </b-button>
                </span>
              </span>

              <!-- Outras colunas -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- Paginação -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">Exibindo</span>
                  <b-form-select
                    v-model="tableConfigs.size"
                    :options="[10, 20, 50]"
                    class="mx-1"
                    @input="handleChangePage(1)"
                  />
                  <span class="text-nowrap">de {{ tableConfigs.totalElements }} registros</span>
                </div>
                <b-pagination
                  :value="pageConfig.page + 1"
                  :total-rows="tableConfigs.totalElements"
                  :per-page="tableConfigs.size"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                >
                  <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
                  <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
                </b-pagination>
              </div>
            </template>
          </vue-good-table>
        </b-card>

        <!-- Formulário inline de inserção -->
        <FormPaymentReceiptAccount
          v-if="showForm"
          title-form="Novo Lançamento Financeiro"
          :combo-payment="comboFormaPagamento"
          :combo-type="comboTipoPagamento"
          :combo-situation="comboSituacao"
          :combo-account="comboContas"
          :object-edit="pagamentoRecebimento"
          @cancelar="cancelar"
          @save="save"
          @change-tipo="handleTipoFormChange"
        />
      </b-col>
    </b-row>

    <!-- Modal de Quitação -->
    <b-modal
      id="modal-quitacao"
      title="Quitar Lançamento"
      ok-title="Confirmar Quitação"
      cancel-title="Cancelar"
      ok-variant="success"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      @ok="confirmarQuitacao"
    >
      <div v-if="lancamentoParaQuitar">
        <b-row class="mb-1">
          <b-col cols="6">
            <small class="text-muted d-block">Descrição</small>
            <strong>{{ lancamentoParaQuitar.descricao }}</strong>
          </b-col>
          <b-col cols="6">
            <small class="text-muted d-block">Valor Total</small>
            <strong class="text-primary">{{ formatCurrencyBrazil(lancamentoParaQuitar.valorTotal) }}</strong>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="6">
            <small class="text-muted d-block">Valor já quitado</small>
            <span>{{ formatCurrencyBrazil(lancamentoParaQuitar.valorQuitado || 0) }}</span>
          </b-col>
          <b-col cols="6">
            <small class="text-muted d-block">Valor Pendente</small>
            <strong class="text-warning">{{
              formatCurrencyBrazil(
                (lancamentoParaQuitar.valorTotal || 0) - (lancamentoParaQuitar.valorQuitado || 0)
              )
            }}</strong>
          </b-col>
        </b-row>
        <hr />
        <b-form-group label="Valor a Quitar *" label-for="quitar-valor">
          <b-input-group prepend="R$">
            <b-form-input
              id="quitar-valor"
              v-model="quitacao.valorQuitado"
              type="number"
              step="0.01"
              min="0.01"
              :max="(lancamentoParaQuitar.valorTotal || 0) - (lancamentoParaQuitar.valorQuitado || 0)"
            />
            <b-input-group-append>
              <b-button variant="outline-primary" size="sm" @click="quitarTotal">
                Quitar Total
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group label="Data de Quitação *" label-for="quitar-data">
          <b-form-input
            id="quitar-data"
            v-model="quitacao.dataQuitacao"
            type="date"
            required
          />
        </b-form-group>

        <b-form-group label="Forma de Pagamento" label-for="quitar-forma">
          <b-form-select
            id="quitar-forma"
            v-model="quitacao.formaPagamentoId"
            :options="comboFormaPagamento"
            value-field="id"
            text-field="nome"
          >
            <template #first>
              <b-form-select-option :value="null">Selecione...</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group label="Observações" label-for="quitar-obs">
          <b-form-textarea
            id="quitar-obs"
            v-model="quitacao.observacao"
            rows="2"
            placeholder="Observações sobre o pagamento (opcional)"
          />
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import {
  BRow, BCol, BCard, BCardBody, BBadge, BButton, BPagination,
  BFormGroup, BFormInput, BFormSelect, BFormSelectOption,
  BFormTextarea, BModal, BInputGroup, BInputGroupAppend,
  VBTooltip
} from 'bootstrap-vue'
import FormPaymentReceiptAccount from '@/layouts/components/FormPaymentReceiptAccount.vue'
import mixinsGlobal from '@/mixins'
import store from '@/store/index'
import _ from 'lodash'

export default {
  name: 'TransacoesFinanceiras',
  components: {
    BRow, BCol, BCard, BCardBody, BBadge, BButton, BPagination,
    BFormGroup, BFormInput, BFormSelect, BFormSelectOption,
    BFormTextarea, BModal, BInputGroup, BInputGroupAppend,
    VueGoodTable, FormPaymentReceiptAccount
  },
  directives: { 'b-tooltip': VBTooltip },
  mixins: [mixinsGlobal],

  computed: {
    ...mapState('combosModule', {
      comboFormaPagamento: state => state.comboFormaPagamento,
      comboTipoPagamento: state => state.comboTipoPagamentoPorTipo,
      comboContas: state => state.comboContas
    }),
    ...mapState('pagamentoRecebimentoFinancialModule', {
      listaPagamentoRecebimentos: state => state.listaPagamentoRecebimentos,
      pagamentoRecebimento: state => state.pagamentoRecebimento,
      comboSituacao: state => state.comboSituacao,
      totalizacao: state => state.totalizacao
    }),
    direction() {
      return store.state.appConfig.isRTL
    },
    tituloTabela() {
      const map = { null: 'Todas as Transações', '-1': 'Todas as Transações', '0': 'Contas a Pagar', '1': 'Contas a Receber' }
      return map[String(this.filter.tipoTransacao)] || 'Todas as Transações'
    }
  },

  data() {
    const hoje = new Date()
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)
    const toInputDate = d => d.toISOString().split('T')[0]

    return {
      isLoading: false,
      showForm: false,
      lancamentoParaQuitar: null,
      quitacao: { valorQuitado: 0, dataQuitacao: toInputDate(hoje), formaPagamentoId: null, observacao: '' },
      totaisCards: { totalReceita: 0, totalDespesa: 0, saldoAtual: 0, totalPendente: 0 },
      dicionarioTipos: { receitasIds: [], despesasIds: [] },

      filter: {
        tipoTransacao: -1,   // -1 = todos | 0 = pagar | 1 = receber
        situacao: -1,
        dataInicio: toInputDate(primeiroDia),
        dataFinal: toInputDate(ultimoDia),
        campo: ''
      },

      pageConfig: { page: 1, size: 10, sort: 'dataLancamento', order: 'desc' },
      tableConfigs: { totalElements: 0, totalPages: 0, size: 10 },

      opcoestipoTransacao: [
        { value: -1, label: 'Todos' },
        { value: 0,  label: 'Contas a Pagar' },
        { value: 1,  label: 'Contas a Receber' }
      ],
      opcoesSituacao: [
        { value: -1,   label: 'Todas' },
        { value: 0,    label: 'Aberto' },
        { value: 1,    label: 'Vencido' },
        { value: 2,    label: 'Quitado' },
        { value: 3,    label: 'Pago a Menor' },
        { value: 4,    label: 'Cancelado' }
      ],

      columns: [
        { label: 'Data Lançamento', field: 'dataLancamento', formatFn: this.formatDateGrid, sortable: true },
        { label: 'Membro',          field: 'registro.nome',   sortable: false },
        { label: 'Descrição',       field: 'descricao',       sortable: false },
        { label: 'Tipo',            field: 'tipoBadge',       sortable: false },
        { label: 'Valor',           field: 'valor',           sortable: false },
        { label: 'Vencimento',      field: 'dataVencimento',  formatFn: this.formatDateGrid, sortable: false },
        { label: 'Quitação',        field: 'dataQuitacao',    formatFn: this.formatDateGrid, sortable: false },
        { label: 'Situação',        field: 'situacao',        sortable: false },
        { label: 'Ações',           field: 'action',          sortable: false }
      ]
    }
  },

  async mounted() {
    this.isLoading = true
    
    // Carrega dicionario mestre de IDs de categoria para a Grid saber pintar Verde ou Vermelho
    try {
      const [resDesp, resRec, resRecEmp] = await Promise.all([
        this.$store.dispatch('combosModule/loadComboTipoPagamentoPorTipo', 0),
        this.$store.dispatch('combosModule/loadComboTipoPagamentoPorTipo', 1),
        this.$store.dispatch('combosModule/loadComboTipoPagamentoPorTipo', 2)
      ])
      if (resDesp && resDesp.data) this.dicionarioTipos.despesasIds = resDesp.data.map(t => t.id)
      
      const receitas = resRec && resRec.data ? resRec.data.map(t => t.id) : []
      const emprestimos = resRecEmp && resRecEmp.data ? resRecEmp.data.map(t => t.id) : []
      this.dicionarioTipos.receitasIds = [...receitas, ...emprestimos]
    } catch (e) {
      console.error('Falha ao carregar dicionário de tipos')
    }

    await this.carregarTotalizacao()
    // Carrega Formas de Pagamento preventivamente para o Modal de Quitação
    await this.$store.dispatch('combosModule/loadComboFormaPagamento')
    await this.carregarTabela()
    this.isLoading = false
  },

  methods: {
    // --- Carregamento ---
    async carregarTotalizacao() {
      // Como a API /filtros/cards só traz valor quitado, calcularemos os cards com base no filtro da tela
      // rodando a query com size 10000 para pegar todos os registros do período
      const filtroApi = this.montarFiltroApi()
      try {
        const result = await this.$store.dispatch('pagamentoRecebimentoFinancialModule/filterAllTransacoes', {
          filter: filtroApi,
          pageConfig: { page: 0, size: 10000, sort: 'dataLancamento', order: 'desc' }
        })
        
        let receitas = 0
        let despesas = 0
        let pendente = 0
        
        if (result && result.data && result.data.content) {
          result.data.content.forEach(row => {
            const rowTipoId = row.tipo ? row.tipo.id : null
            const isRet = this.dicionarioTipos.receitasIds.includes(rowTipoId)
            const isDesp = this.dicionarioTipos.despesasIds.includes(rowTipoId)
            
            const valTotal = parseFloat(row.valorTotal || 0)
            const valQuitado = parseFloat(row.valorQuitado || 0)
            
            // Soma de receita/despesa total do período (Independente se quitou ou não)
            if (isRet) receitas += valTotal
            if (isDesp) despesas += valTotal
            
            // Valores Pendentes gerais (Receber ou Pagar que faltam quitar)
            if (row.situacao === 'ABERTO' || row.situacao === 'VENCIDO' || row.situacao === 'PAGO_A_MENOR') {
              pendente += (valTotal - valQuitado)
            }
          })
        }
        
        // Atualiza os valores locais
        // Utilizando this.$set caso precisemos garantir reatividade
        this.totaisCards = {
          totalReceita: receitas,
          totalDespesa: despesas,
          saldoAtual: receitas - despesas, // Saldo do periodo (Receitas x Despesas)
          totalPendente: pendente
        }

      } catch (err) {
        console.error('Erro ao somar cards:', err)
      }
    },

    async carregarTabela() {
      const filtroApi = this.montarFiltroApi()
      try {
        const result = await this.$store.dispatch(
          'pagamentoRecebimentoFinancialModule/filterAllTransacoes',
          { filter: filtroApi, pageConfig: this.pageConfig }
        )
        this.atualizarPaginacao(result)
      } catch (err) {
        this.MensagemError('Erro ao carregar transações', err.message)
      } finally {
        this.isLoading = false
      }
    },

    montarFiltroApi() {
      // tipo: -1 = todos | 0 = pagar | 1 = receber (conforme FilterComponents.vue)
      const tipo = this.filter.tipoTransacao !== null ? this.filter.tipoTransacao : -1
      // Datas: converter de YYYY-MM-DD (input[date]) p/ dd/mm/YYYY (formato do backend)
      const fmtData = (d) => {
        if (!d) return null
        const parts = d.split('-')
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
        return d
      }
      return {
        tipo,
        dataInicio: fmtData(this.filter.dataInicio),
        dataFinal: fmtData(this.filter.dataFinal),
        situacao: this.filter.situacao,
        campo: this.filter.campo || ''
      }
    },

    atualizarPaginacao(result) {
      if (result && result.data) {
        this.tableConfigs.totalElements = result.data.totalElements
        this.tableConfigs.totalPages = result.data.totalPages
        this.tableConfigs.size = result.data.size
        this.pageConfig.page = result.data.pageable.pageNumber
      }
    },

    // --- Filtros e paginação ---
    async aplicarFiltro() {
      this.pageConfig.page = 0
      this.isLoading = true
      
      // Carrega ambos independentes ou juntos
      await Promise.all([
        this.carregarTotalizacao(),
        this.carregarTabela()
      ])
      
      this.isLoading = false
    },

    handleSearch: _.debounce(function () {
      this.aplicarFiltro()
    }, 500),

    handleChangePage(page) {
      this.pageConfig.page = page - 1
      this.pageConfig.size = this.tableConfigs.size
      this.carregarTabela()
    },

    onSortChange(params) {
      this.pageConfig.sort = params[0].field
      this.pageConfig.order = params[0].type
      this.carregarTabela()
    },

    // --- Badges helpers ---
    getTipoBadgeVariant(row) {
      if (!row || !row.tipo) return 'light-secondary'
      if (this.dicionarioTipos.receitasIds.includes(row.tipo.id)) return 'light-success'
      if (this.dicionarioTipos.despesasIds.includes(row.tipo.id)) return 'light-danger'
      
      // Fallback
      const isString = typeof row.tipo === 'string'
      const nome = isString ? row.tipo.toUpperCase() : (row.tipo.nome || row.tipo.descricao || '').toUpperCase()
      if (nome.includes('RECEITA') || nome.includes('RECEB')) return 'light-success'
      if (nome.includes('DESPESA') || nome.includes('PAG')) return 'light-danger'
      return 'light-secondary'
    },
    getTipoLabel(row) {
      if (!row || !row.tipo) return '-'
      if (this.dicionarioTipos.receitasIds.includes(row.tipo.id)) return 'Receita'
      if (this.dicionarioTipos.despesasIds.includes(row.tipo.id)) return 'Despesa'
      
      // Fallback
      const isString = typeof row.tipo === 'string'
      const nome = isString ? row.tipo.toUpperCase() : (row.tipo.nome || row.tipo.descricao || '').toUpperCase()
      if (nome.includes('RECEITA') || nome.includes('RECEB')) return 'Receita'
      if (nome.includes('DESPESA') || nome.includes('PAG')) return 'Despesa'
      return isString ? row.tipo : row.tipo.nome || row.tipo.descricao || '-'
    },
    getSituacaoBadgeVariant(situacao) {
      const map = {
        ABERTO: 'light-info',
        VENCIDO: 'light-warning',
        QUITADO: 'light-success',
        PAGO_A_MENOR: 'light-primary',
        CANCELADO: 'light-secondary'
      }
      return map[situacao] || 'light-secondary'
    },
    getSituacaoLabel(situacao) {
      const map = {
        ABERTO: 'Aberto',
        VENCIDO: 'Vencido',
        QUITADO: 'Quitado',
        PAGO_A_MENOR: 'Pago a Menor',
        CANCELADO: 'Cancelado'
      }
      return map[situacao] || situacao || '-'
    },

    // --- CRUD ---
    async addNew() {
      await Promise.all([
        this.$store.dispatch('combosModule/loadComboTipoPagamentoPorTipo', 0),
        this.$store.dispatch('combosModule/loadComboContas')
      ])
      this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      this.showForm = true
    },

    async handleTipoFormChange(tipo) {
      // Dispara do Filho quando o usuário muda o RadioButton de Tipo da Inclusão (Receita x Despesa)
      await this.$store.dispatch('combosModule/loadComboTipoPagamentoPorTipo', tipo)
    },

    edit(row) {
      this.$router.push({ name: 'editTransacoes', params: { id: row.id } })
    },

    cancelar() {
      this.showForm = false
    },

    prepareForSave(data) {
      const obj = JSON.parse(JSON.stringify(data))
      return {
        registro: obj.registro,
        descricao: obj.descricao,
        dataLancamento: obj.dataLancamento,
        dataVencimento: obj.dataVencimento,
        dataQuitacao: obj.dataQuitacao,
        valor: obj.valor,
        desconto: obj.desconto,
        juro: obj.juro,
        multa: obj.multa,
        valorTotal: obj.valor,
        valorQuitado: obj.valorQuitado,
        observacao: obj.observacao,
        tipo: { id: obj.tipo },
        formaPagamento: { id: obj.formaPagamento },
        conta: obj.conta ? { id: obj.conta } : null,
        situacao: obj.situacao,
        ativo: obj.ativo,
        qtoRepetido: obj.qtoRepetido
      }
    },

    async save(data) {
      if (!data.registro || !data.registro.id) {
        this.MensagemError('Atenção', 'Selecione um membro/associado válido.')
        return
      }
      const payload = this.prepareForSave(data)
      const response = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/insertNewPagamentoRecebimento',
        payload
      )
      if (response && response.response && response.response.data) {
        const errs = response.response.data.errors
        this.MensagemError(
          'Falha ao salvar',
          errs ? errs[0].message : response.response.data.message
        )
        return
      }
      this.showMessageSuccess('Sucesso', 'Lançamento incluído com sucesso!')
      this.cancelar()
      this.carregarTabela()
      await this.carregarTotalizacao()
    },

    remove(row) {
      this.$swal({
        title: 'Excluir lançamento?',
        text: `"${row.descricao}" será removido permanentemente.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-danger mr-1',
          cancelButton: 'btn btn-outline-secondary'
        },
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          const response = await this.$store.dispatch(
            'pagamentoRecebimentoFinancialModule/delete',
            row.id
          )
          if (response && response.data && response.data.error) {
            this.MensagemError('Erro ao excluir', response.data.message)
            return
          }
          this.showMessageSuccess('Excluído', 'Lançamento removido com sucesso!')
          this.carregarTabela()
          await this.carregarTotalizacao()
        }
      })
    },

    // --- Quitação ---
    abrirModalQuitacao(row) {
      this.lancamentoParaQuitar = row
      const pendente = (row.valorTotal || 0) - (row.valorQuitado || 0)
      
      // Criar uma nova referência do objeto para forçar Vue a notar a mudança
      this.quitacao = Object.assign({}, this.quitacao, {
        valorQuitado: pendente,
        dataQuitacao: new Date().toISOString().split('T')[0],
        formaPagamentoId: row.formaPagamento ? row.formaPagamento.id : null,
        observacao: ''
      })
      
      this.$bvModal.show('modal-quitacao')
    },

    quitarTotal() {
      const pendente = (this.lancamentoParaQuitar.valorTotal || 0) -
                       (this.lancamentoParaQuitar.valorQuitado || 0)
      
      // Nova referência direta no input
      this.quitacao = Object.assign({}, this.quitacao, {
        valorQuitado: pendente
      })
    },

    async confirmarQuitacao(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (!this.quitacao.dataQuitacao) {
        this.MensagemError('Atenção', 'Informe a data de quitação.')
        return
      }
      const payload = {
        ...this.lancamentoParaQuitar,
        situacao: parseFloat(this.quitacao.valorQuitado) >= parseFloat(this.lancamentoParaQuitar.valorTotal)
          ? 'QUITADO'
          : 'PAGO_A_MENOR',
        valorQuitado: parseFloat(this.quitacao.valorQuitado),
        dataQuitacao: this.quitacao.dataQuitacao,
        observacao: this.quitacao.observacao,
        formaPagamento: this.quitacao.formaPagamentoId
          ? { id: this.quitacao.formaPagamentoId }
          : this.lancamentoParaQuitar.formaPagamento
      }
      const response = await this.$store.dispatch(
        'pagamentoRecebimentoFinancialModule/editPagamentoRecebimento',
        payload
      )
      if (response && response.response) {
        this.MensagemError('Falha na quitação', response.response.data?.message || 'Erro desconhecido')
        return
      }
      this.showMessageSuccess('Quitado!', 'Lançamento quitado com sucesso.')
      this.$bvModal.hide('modal-quitacao')
      this.carregarTabela()
      await this.carregarTotalizacao()
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';

.gap-50 {
  gap: 0.25rem;
}
</style>
